<div class="wc-section {{ to.fieldGroupClassName }}" *ngIf="!areAllFieldsHidden">
  <div class="wc-section-header">
    <div class="d-flex align-items-center">
      <mat-checkbox *ngIf="props.canDeactivate === true" [(ngModel)]="props.isActive" (change)="onToggle($event)">
        <h3 class="text bold m-0">{{ props.label | apmTranslate }}</h3>
      </mat-checkbox>
      <h3 class="text bold" *ngIf="props.canDeactivate === undefined">{{ props.label | apmTranslate }}</h3>
    </div>
    <div class="italic-2" *ngIf="props.subtitle">{{ props.subtitle | apmTranslate }}</div>
  </div>
  <div class="wc-section-body" [ngClass]="{ 'bg-editable-row': to.editable && (isEditing$ | async) }">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
